document.addEventListener("DOMContentLoaded", function () {
  const activeClass = "single-product__menu-tab--active";

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute("id");
        const menuLink = document.querySelector(`a[href="#${id}"]`);
        const menuTab = menuLink.parentNode;
        if (entry.isIntersecting) {
          if (menuTab && !menuTab.classList.contains(activeClass)) {
            menuTab.classList.add(activeClass);
          }
        } else {
          if (menuTab && menuTab.classList.contains(activeClass)) {
            menuTab.classList.remove(activeClass);
          }
        }
      });
    },
    {
      rootMargin: "-20% 0px -80%",
      root: document,
    }
  );

  const productSections = document.querySelectorAll(
    ".single-product__menu-target[id^=product-]"
  );

  if (productSections && productSections.length) {
    productSections.forEach((header) => {
      observer.observe(header);
    });
  }
  
  const resourcesSection = document.querySelector("#product-resources");
  const resourcesTab = document.querySelector(
    'a[href="#product-resources"]'
  )?.parentNode;

  if (!resourcesSection && resourcesTab) {
    resourcesTab.remove();
  }
});
